// components/tabs/PredictTab.jsx
// 实时预测: 输入面板 + 查询点定位

import TernaryDiagram from '../viz/TernaryDiagram';
import { useSolPred } from '../../hooks/useSolPredStore';

export default function PredictTab() {
  const {
    selectedSystem, temperature, handleTempChange,
    dataPoints, predictions, invariantPoints, phaseList,
    hoveredPoint, setHoveredPoint,
    selectedPoint, setSelectedPoint,
    liveW1, setLiveW1, liveW2, setLiveW2,
    liveResult, predicting, runLivePrediction,
  } = useSolPred();

  return (
    <div className="fade-in" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
      {/* 输入面板 */}
      <div className="canvas-card">
        <div className="canvas-header">
          <div>
            <div className="canvas-title">实时预测 · Live Inference</div>
            <div className="canvas-subtitle">输入组成，PC-CVAE 给出饱和判据 + 预测固相</div>
          </div>
        </div>
        <div style={{ padding: '8px 0' }}>
          <div className="panel-title">输入参数</div>
          <div className="input-row">
            <span className="input-label">w({selectedSystem.components[0]})</span>
            <input
              type="number" step="0.01" min="0" max="0.5"
              className="input-num"
              value={liveW1}
              onChange={e => setLiveW1(+e.target.value)}
            />
          </div>
          <div className="input-row">
            <span className="input-label">w({selectedSystem.components[1]})</span>
            <input
              type="number" step="0.01" min="0" max="0.5"
              className="input-num"
              value={liveW2}
              onChange={e => setLiveW2(+e.target.value)}
            />
          </div>
          <div className="input-row">
            <span className="input-label">T (°C)</span>
            <input
              type="number" step="1"
              min={selectedSystem.tempRange[0]}
              max={selectedSystem.tempRange[1]}
              className="input-num"
              value={temperature}
              onChange={e => handleTempChange(+e.target.value)}
            />
          </div>
          <div className="input-row">
            <span className="input-label">w(H₂O)</span>
            <input
              className="input-num" disabled
              value={(1 - liveW1 - liveW2).toFixed(4)}
              style={{ color: 'var(--text-3)' }}
            />
          </div>

          <button
            className="predict-btn"
            onClick={runLivePrediction}
            disabled={!selectedSystem.hasModel || predicting || (1 - liveW1 - liveW2) < 0}
            style={{ marginTop: 14 }}
          >
            {predicting ? '⟳ 推理中...' : '→ 运行 PC-CVAE 推理'}
          </button>

          {liveResult && (
            <div className="live-result">
              <div className="live-result-row">
                <span className="live-result-label">饱和状态</span>
                <span className={`live-result-value ${liveResult.saturated ? 'danger' : 'success'}`}>
                  {liveResult.saturated ? '● 已饱和' : '○ 未饱和'}
                </span>
              </div>
              <div className="live-result-row">
                <span className="live-result-label">预测固相</span>
                <span className="live-result-value accent">{liveResult.phase}</span>
              </div>
              <div className="live-result-row">
                <span className="live-result-label">距饱和线</span>
                <span className="live-result-value">{liveResult.distance}</span>
              </div>
              <div className="live-result-row">
                <span className="live-result-label">w(H₂O)</span>
                <span className="live-result-value">{liveResult.ww}</span>
              </div>
              <div className="live-result-row">
                <span className="live-result-label">置信度</span>
                <span className="live-result-value">{(liveResult.confidence * 100).toFixed(1)} %</span>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* 查询点在三角图上的位置 */}
      <div className="canvas-card">
        <div className="canvas-header">
          <div>
            <div className="canvas-title">查询点定位</div>
            <div className="canvas-subtitle">在 T = {temperature}°C 等温相图上展示输入点</div>
          </div>
        </div>
        <div className="diagram-box" style={{ minHeight: 380 }}>
          <div className="diagram-svg-wrap">
            <TernaryDiagram
              dataPoints={dataPoints}
              predictions={predictions}
              invariantPoints={invariantPoints}
              labels={selectedSystem.components}
              showPrediction={selectedSystem.hasModel}
              showRegions={false}
              hoveredPoint={hoveredPoint}
              onHoverPoint={setHoveredPoint}
              selectedPhase="all"
              phaseList={phaseList}
              livePoint={{ w1: liveW1, w2: liveW2 }}
              selectedPointId={selectedPoint?.id}
              onSelectPoint={(pt) => setSelectedPoint({ kind: 'experimental', ...pt })}
              onSelectCurvePoint={(cp) => setSelectedPoint({
                kind: cp.isInvariant ? 'invariant' : 'prediction',
                id: `curve-${cp.segIdx}-${cp.idx}-${temperature}`,
                w1: cp.w1, w2: cp.w2,
                ww: cp.ww !== undefined ? cp.ww : 1 - cp.w1 - cp.w2,
                temp: temperature,
                solidPhase: cp.phaseLabel,
                color: cp.color,
                source: cp.isInvariant ? 'PC-CVAE 不变点' : 'PC-CVAE 预测曲线',
                uncertainty: 0.005,
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
